import { getStore } from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('setCurrentSearchQueryId', function (currentSearchQueryId) {
    getStore().currentSearchQueryId = currentSearchQueryId;
});
//# sourceMappingURL=setCurrentSearchQueryId.js.map